/* ============================================================
   PLUSHIE PATCH — recently viewed (localStorage)
   Records products on product pages, renders them anywhere
   a #ppRecentlyViewed container exists.
   ============================================================ */
(function () {
  "use strict";
  var KEY = 'pp_recently_viewed';
  var MAX = 8;

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }

  document.addEventListener('DOMContentLoaded', function () {
    // record current product (set by the product template)
    var cur = window.PP_CURRENT_PRODUCT;
    if (cur && cur.handle) {
      var list = read().filter(function (p) { return p.handle !== cur.handle; });
      list.unshift(cur);
      write(list.slice(0, MAX));
    }
    render(cur ? cur.handle : null);
  });

  function render(excludeHandle) {
    var grid = document.getElementById('ppRecentlyViewed');
    var section = document.getElementById('ppRecentlySection');
    if (!grid) return;
    var items = read().filter(function (p) { return p.handle !== excludeHandle; });
    if (items.length === 0) return;

    grid.innerHTML = items.map(function (p) {
      var img = p.image ? '<img src="' + p.image + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '';
      return '<a class="rel-card" href="' + p.url + '">' +
               '<div class="rel-img">' + img + '</div>' +
               '<div class="rel-info"><h4>' + (p.title || '') + '</h4><span class="rel-price">' + (p.price || '') + '</span></div>' +
             '</a>';
    }).join('');
    if (section) section.hidden = false;
  }
})();
